import L from 'leaflet'
import { useEffect } from 'react'

import { MapMode } from '../region-map'

interface UseToggleMapModeParams {
  mapRef: React.RefObject<L.Map | null>
  mapMode: MapMode
  setMapMode: (mode: MapMode) => void
}

export const useToggleMapMode = ({
  mapRef,
  mapMode,
  setMapMode,
}: UseToggleMapModeParams) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    const activeElement = document.activeElement as HTMLElement
    const isInputFocused =
      !!activeElement &&
      activeElement.tagName === 'INPUT' &&
      (activeElement as HTMLInputElement).type !== 'checkbox'

    if (event.code === 'Space' && !isInputFocused) {
      event.preventDefault()
      const newMode =
        mapMode === 'navigation' ? 'multipleSelection' : 'navigation'
      setMapMode(newMode)
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [handleKeyDown])

  useEffect(() => {
    const shouldDrag = mapMode === 'navigation'

    shouldDrag
      ? mapRef.current?.dragging.enable()
      : mapRef.current?.dragging.disable()

    if (mapRef.current) {
      mapRef.current.getContainer().style.cursor = !shouldDrag
        ? 'crosshair'
        : ''
    }
  }, [mapRef, mapMode])
}
